const WHATSAPP_MESSAGE = encodeURIComponent(
  "Olá! Vim pelo site da Eco Build e gostaria de solicitar um orçamento."
);

export const BRAND = {
  name: "Eco Build Group Solution",
  wordmark: "engenharia",
  email: "comercialecobuild@outlook.com",
  whatsappDisplay: "+55 (21) 96479-9948",
  whatsappUrl: `https://wa.me/5521964799948?text=${WHATSAPP_MESSAGE}`,
};

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1533163238111-4a7ced54f2e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHx3YXN0ZXdhdGVyJTIwdHJlYXRtZW50fGVufDB8fHx8MTc5MTY4OTI4NHww&ixlib=rb-4.1.0&q=85",
  eteEta:
    "https://images.unsplash.com/photo-1533077162801-86490c593afb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHx3YXN0ZXdhdGVyJTIwdHJlYXRtZW50fGVufDB8fHx8MTc5MTY4OTI4NHww&ixlib=rb-4.1.0&q=85",
  chorume:
    "https://images.unsplash.com/photo-1622322977879-af6982dcba00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHx3YXN0ZXdhdGVyJTIwdHJlYXRtZW50fGVufDB8fHx8MTc5MTY4OTI4NHww&ixlib=rb-4.1.0&q=85",
  fotovoltaica:
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJlbmV3YWJsZXxlbnwwfHx8fDE3OTE2ODkyODV8MA&ixlib=rb-4.1.0&q=85",
  infraEletrica:
    "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVscyUyMHJlbmV3YWJsZXxlbnwwfHx8fDE3OTE2ODkyODV8MA&ixlib=rb-4.1.0&q=85",
  construcaoSeca:
    "https://images.unsplash.com/photo-1493476523860-a6de6ce1b0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxzdGVlbCUyMGZyYW1lJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc5MTY4OTI4NHww&ixlib=rb-4.1.0&q=85",
  steelFrame:
    "https://images.unsplash.com/uploads/14123892966835548e7bd/14369636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMGZyYW1lJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc5MTY4OTI4NHww&ixlib=rb-4.1.0&q=85",
  gestao:
    "https://images.unsplash.com/photo-1694521787162-5373b598945c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxjaXZpbCUyMGVuZ2luZWVyaW5nJTIwc2l0ZXxlbnwwfHx8fDE3OTE2ODkyODV8MA&ixlib=rb-4.1.0&q=85",
  reformas:
    "https://images.unsplash.com/photo-1768677903496-becc4be07258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxjaXZpbCUyMGVuZ2luZWVyaW5nJTIwc2l0ZXxlbnwwfHx8fDE3OTE2ODkyODV8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "sobre", label: "Sobre" },
  { id: "servicos", label: "Serviços" },
  { id: "projetos", label: "Projetos" },
  { id: "case", label: "Case" },
  { id: "contatos", label: "Contatos" },
];

export const PROJECT_FILTERS = [
  { id: "todos", label: "Todos" },
  { id: "ambiental", label: "ETE / ETA" },
  { id: "chorume", label: "Chorume" },
  { id: "fotovoltaica", label: "Fotovoltaica" },
  { id: "construcao-seca", label: "Construção Seca" },
];

export const PROJECTS = [
  {
    id: "ete-condominio",
    title: "ETE Compacta — Condomínio Parque das Águas",
    tag: "ambiental",
    tagLabel: "ETE / ETA",
    location: "Rio de Janeiro · RJ",
    year: "2024",
    capacity: "240 m³/dia",
    image: IMAGES.eteEta,
    scope:
      "Implantação completa de estação de tratamento de esgoto compacta, com sistema de aeração prolongada, decantação secundária e reuso de água para irrigação.",
    span: "lg:col-span-7",
  },
  {
    id: "chorume-aterro",
    title: "Tratamento de Chorume — Aterro Sanitário",
    tag: "chorume",
    tagLabel: "Chorume",
    location: "São Gonçalo · RJ",
    year: "2023",
    capacity: "60 m³/dia",
    image: IMAGES.chorume,
    scope:
      "Sistema de tratamento de percolado (chorume) com processo físico-químico e biológico, atendendo aos padrões de lançamento da CONAMA 430.",
    span: "lg:col-span-5",
  },
  {
    id: "usina-solar",
    title: "Usina Solar Fotovoltaica Industrial",
    tag: "fotovoltaica",
    tagLabel: "Fotovoltaica",
    location: "Duque de Caxias · RJ",
    year: "2024",
    capacity: "850 kWp",
    image: IMAGES.fotovoltaica,
    scope:
      "Projeto, homologação e montagem de usina solar de geração distribuída para autoprodução industrial, com payback estimado em 4 anos.",
    span: "lg:col-span-5",
  },
  {
    id: "steel-frame",
    title: "Edifício Comercial em Steel Frame",
    tag: "construcao-seca",
    tagLabel: "Construção Seca",
    location: "Niterói · RJ",
    year: "2023",
    capacity: "4.200 m²",
    image: IMAGES.steelFrame,
    scope:
      "Construção seca completa com estrutura leve em steel frame, fechamento em placas cimentícias e alto desempenho termoacústico, com redução de 70% de resíduos.",
    span: "lg:col-span-7",
  },
  {
    id: "eta-modular",
    title: "ETA Modular Municipal",
    tag: "ambiental",
    tagLabel: "ETE / ETA",
    location: "Itaboraí · RJ",
    year: "2025",
    capacity: "1.200 m³/dia",
    image: IMAGES.heroBg,
    scope:
      "Estação de tratamento de água modular com floculação, decantação lamelar e desinfecção, ampliando o abastecimento de comunidades do entorno.",
    span: "lg:col-span-6",
  },
  {
    id: "retrofit-industrial",
    title: "Retrofit e Reforma de Planta Industrial",
    tag: "construcao-seca",
    tagLabel: "Construção Seca",
    location: "Rio de Janeiro · RJ",
    year: "2024",
    capacity: "6.800 m²",
    image: IMAGES.reformas,
    scope:
      "Reforma de alta complexidade em planta industrial ativa, com reforço estrutural, modernização de instalações e gestão integrada de cronograma.",
    span: "lg:col-span-6",
  },
];
